import { useUnriddle } from '@/context/UnriddleContext';
import useAnalytics from '@/lib/analytics/useAnalytics';
import { BellIcon, X } from 'lucide-react';
import { motion } from 'motion/react';
import { Button } from '../Button/Button';

export const UgcProgramModal = () => {
  const { setShowUgcProgramModal } = useUnriddle();
  const { track } = useAnalytics();

  const formLink =
    'https://docs.google.com/forms/d/1mAzuQo_3wY2RapgC4JS_YRKA6QlWuKHSDM1zWLAkObo/prefill';

  const handleClose = async () => {
    localStorage?.setItem('ugcProgramModalClosed', 'true');
    setShowUgcProgramModal(false);
  };

  const onSubmit = () => {
    window.open(formLink, '_blank');
    track('ugc_program_modal_clicked', {
      method: 'Submit',
    });
    handleClose();
  };
  return (
    <motion.div
      className="bg-popover shadow-feint rounded-xl fixed left-4 bottom-4 h-[360px] w-[328px] border border-border z-[55]"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={{
        initial: { opacity: 0, x: -100 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -100 },
      }}
      transition={{ ease: 'easeOut', duration: 0.3 }}
    >
      <button
        className="absolute top-2 right-2 p-2 focus:outline-none"
        onClick={() => {
          track('ugc_program_modal_closed', {
            method: 'Close',
          });

          handleClose();
        }}
      >
        <X className="w-3 h-3" color="#666666" />
      </button>

      <div className="flex flex-col h-full justify-between">
        <div className="flex flex-col gap-3 p-5 pl-[26px]">
          <div className="flex flex-row gap-1 items-center">
            <BellIcon size={14} strokeWidth={2.5} />
            <span className="text-xs font-semibold">Now hiring</span>
          </div>
          <span className="text-2xl font-semibold text-foreground leading-tight tracking-tight">
            Become an Anara Content Creator
          </span>
          <h1 className="text-base font-medium text-foreground mt-0.5 !tracking-tight">
            Make content about Anara on TikTok and Instagram, gain startup
            experience and get paid while doing it!
          </h1>
        </div>

        <div className="flex flex-col gap-2 items-center px-3 pb-4">
          <Button className="w-full rounded-xl" onClick={onSubmit}>
            Apply
          </Button>
          <span className="text-xs font-semibold text-textGray4">
            For people in the US, UK and Canada
          </span>
        </div>
      </div>
    </motion.div>
  );
};
